export const image = ['jpeg', 'png', 'jpg', 'gif', 'bmp'];
export const audio = [
  'mp3',
  'wav',
  'ogg',
  'oga',
  'mpga',
  'opus',
  'wav',
  'x-wav',
];
export const video = ['mp4', 'm4v'];
export const document = [
  'doc',
  'docx',
  'txt',
  'csv',
  'pdf',
  'xls',
  'xlsx',
  'ppt',
  'pptx',
];
export const compression = ['zip', 'rar', 'gz', '7z'];

export const allAccept = [
  ...image,
  ...audio,
  ...video,
  ...document,
  ...compression,
]
  .map((ext) => `.${ext}`)
  .join(',');

export const malicious = [
  'exe',
  'msi',
  'bat',
  'com',
  'cmd',
  'hta',
  'src',
  'pif',
  'reg',
  'js',
  'vbs',
  'wsf',
  'cpl',
  'jar',
  'dll',
  'deb',
];
